export const Challenge_Criteria_EN = {
  // Toasts used for challenges
  challengeCriteria: {
    headline: "How is the total score calculated?",
    fallguys: {
      headline: "How is the total score calculated?",
      criteria: {
        positionPoints: "Position points",
        medalPoints: "Total Medal points",
        rounds: "Rounds",
        fame: "Fame",
        bronze: "Bronze medals (Top 50%)",
        silver: "Silver medals (Top 20%)",
        gold: "Gold medals (1st place)",
        total_badge_points: "Total badge points",
        finalPoints: "Final points",
      },
      description: {
        positionPoints: "Your placement in the game.",
        medalPoints:
          "First you get points per medal you collect. Bronze medal gives 1 point. Silver medal gives 2 points. Gold medal gives 3 points. We add these points together and call it 'TMP' (Total Medal Points).",
        medalPointsGold: "Gold medal gives 3 points.",
        medalPointsSilver: "Silver medal gives 2 points.",
        medalPointsBronze: "Bronze medal gives 1 point.",
      },
    },
    fm: {
      bestLapTime: "Lap Time",
      distanceTravel: "Distance traveled",
      racePosition: "Race position",
    },
    cs: {
      kills: "Kills",
      assists: "Assists",
      deaths: "Deaths",
      overall_kd: "Overall K/D",
      averageKillStreak: "Average kill streak",
      highestKillStreak: "Highest kill streak",
      totalKillHs: "Headshots",
      averageAmmoRequiredToKill: "Average ammo used per kill",
      mvps: "MVPs",
      score: "Score",
      time: "Time",
    },
    type: {
      fastest: "Fastest",
      least: "Least",
      slowest: "Slowest",
      most: "Most",
    },
  },
};
